import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthService } from '../auth.service';
import { Global } from '../../utilerias/global';
import { EN_SEGUNDO_PLANO } from './peticion-de-fondo';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthService,private globals:Global) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (this.authenticationService.isAuthenticated()) {
            // El reloj de inactividad se reinicia con lo que hace el
            // USUARIO. Una pantalla que se refresca sola no cuenta como
            // actividad: si contara, quien dejara abierta esa pantalla y
            // se fuera no cerraria sesion nunca. El token si se manda,
            // que la peticion sigue necesitando ir autenticada.
            if (!request.context.get(EN_SEGUNDO_PLANO)) {
                this.globals.reinciarTimer();
            }
                   request = request.clone({
                    setHeaders: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-Auth-Token'    :  this.authenticationService.getToken()
                    }
                });
        }

        return next.handle(request);
    }
}
